export default __webpack_public_path__ + "static/media/applicationdroitsocialindiv.331d9951.png";